import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerService } from '../../services/loading-spinner/loading-spinner.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  isLoading = true
  constructor(private loadingSpinnerService: LoadingSpinnerService) {}

  ngOnInit(): void {
    this.loadingSpinnerService.loading$.subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    });
  }
}
